<template>
  <div class="col-md-6">
    <div class="links-status-report-box-sec">
      <h3 class="text-heading-2">Link Status Report</h3>
      <LinkStatusPieChart :client-status-data="clientStatusData" />
    </div>
  </div>
  <div class="col-md-6">
    <div class="links-by-da-box-sec">
      <div class="link-overview-header">
        <h3 class="text-heading-2">Links Overview</h3>
        <label class="switch">
          <input type="checkbox" id="togBtn" />
          <div class="slider round">
            <span class="off" :class="{ active: activeChart === 'total' }" @click="activeChart = 'total'">Total Links</span>
            <span class="mid" :class="{ active: activeChart === 'da' }" @click="activeChart = 'da'">DA Links</span>
            <span class="on" :class="{ active: activeChart === 'dr' }" @click="activeChart = 'dr'">DR Links</span>
          </div>
        </label>
      </div>
      <div v-if="activeChart === 'total'">
        <DADRPieChart v-if="loading == false" :AllDADRStatusData="AllDADRStatusData" />
      </div>
      <div v-else-if="activeChart === 'da'">
        <DAPieChart v-if="loading == false" :DA-status-data="DAStatusData" />
      </div>
      <div v-else-if="activeChart === 'dr'">
        <DRPieChart v-if="loading == false" :DRStatusData="DRStatusData" />
      </div>
    </div>
  </div>
</template>

<script>
import LinkStatusPieChart from "@/components/LinkStatusPieChart.vue";
import DAPieChart from "@/components/DAPieChart.vue";
import DRPieChart from "@/components/DRPieChart.vue";
import DADRPieChart from "@/components/DADRPieChart.vue";
// import { numberFormat } from '@/prod.js';
export default {
  props: ["DAStatusChartData","DRStatusChartData", "AllDADRStatusChartData", "clientStatusChartData"],
  watch: {
    clientStatusChartData() {
      this.clientStatusData = this.clientStatusChartData;
    },
    DAStatusChartData() {
      this.DAStatusData = this.DAStatusChartData;
    },
    DRStatusChartData() {
      this.DRStatusData = this.DRStatusChartData;
    },
    AllDADRStatusChartData() {
      this.AllDADRStatusData = this.AllDADRStatusChartData;
    }
  },
  components: {
    LinkStatusPieChart,
    DAPieChart,
    DRPieChart,
    DADRPieChart,
  },

  mounted() {
    this.clientStatusData = this.clientStatusChartData || [];
    this.DAStatusData = this.DAStatusChartData;
    this.DRStatusData = this.DRStatusChartData;
    this.AllDADRStatusData = this.AllDADRStatusChartData;
  },
  data() {
    return {
      loading: false,
      activeChart: "total",
      isToggled: false,
      clientStatusData: [],
      DAStatusData: [],
      DRStatusData: [],
      AllDADRStatusData: [],
    };
  },

  methods: {
    // normalizeChartData(list) {
    //   if (!Array.isArray(list)) return [];
    //   const merged = new Map();
    //   list.forEach((item) => {
    //     const label = String(item?.label || item?.labels || "").trim();
    //     if (!label) return;
    //     const count = Number(item?.link_count || 0);
    //     merged.set(label, (merged.get(label) || 0) + count);
    //   });
    //   return Array.from(merged.entries())
    //     .filter(([, link_count]) => Number(link_count) > 0)
    //     .map(([labels, link_count]) => ({
    //       labels,
    //       link_count,
    //     }));
    // },
  },
  computed: {
  },
};
</script>

<style>
.links-by-da-box-sec .link-overview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}

.links-by-da-box-sec .link-overview-header .text-heading-2 {
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
}

.links-by-da-box-sec .link-overview-header .switch {
  flex: 0 0 auto;
}

.links-by-da-box-sec .switch {
  position: relative;
  display: inline-block;
  width: 288px;
  height: 34px;
  z-index: 4;
}

.links-by-da-box-sec .switch input {
  display: none;
}

.links-by-da-box-sec .switch  .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #EDF0F7;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.links-by-da-box-sec .switch .on,
.links-by-da-box-sec .switch .mid,
.links-by-da-box-sec .switch .off{
    padding: 6px 2px;
    display: inline-block;
    font-size: 13px;
    border-radius: 50px;
    color: #0A0E31;
    width: 96px;
    text-align: center;
    box-sizing: border-box;
}



/*------ ADDED CSS ---------*/
.links-by-da-box-sec .switch  .active {
    background-color: #00b6cb;
    color: #fff;

}

/*--------- END --------*/

/* Rounded sliders */
.links-by-da-box-sec .switch .slider.round {
  border-radius: 34px;
}

</style>